// extracted by mini-css-extract-plugin
module.exports = {"tooltipContainer":"styles_tooltipContainer__2scOS"};